module.exports = __webpack_public_path__ + "static/media/019.def155f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/019.jpg
// module id = 526
// module chunks = 0